module.exports = __webpack_public_path__ + "static/media/AFRL.a1a1f8c8.jpeg";